var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "banner", class: ["page-banner", _vm.classObject] }, [
    _c("div", { staticClass: "page-banner__header" }, [
      _c(
        "div",
        { staticClass: "page-banner__banner", style: _vm.styleObject },
        [
          _vm.bgVideo
            ? _c(
                "video",
                {
                  ref: "video",
                  staticClass: "page-banner__video",
                  attrs: { loop: "", muted: "", playsinline: "", autoplay: "" },
                  domProps: { muted: true }
                },
                [
                  _vm.videoData.mp4
                    ? _c("source", {
                        attrs: { src: _vm.videoData.mp4, type: "video/mp4" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.videoData.webm
                    ? _c("source", {
                        attrs: { src: _vm.videoData.webm, type: "video/webm" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.videoData.ogv
                    ? _c("source", {
                        attrs: { src: _vm.videoData.ogv, type: "video/ogg" }
                      })
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("h1", { staticClass: "page-banner__title" }, [_vm._t("title")], 2),
        _vm._v(" "),
        this.$slots.text && _vm.contentInner
          ? _c("div", { staticClass: "page-banner__text" }, [_vm._t("text")], 2)
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    this.$slots.text && !_vm.contentInner
      ? _c("div", { staticClass: "page-banner__info" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "page-banner__text" }, [_vm._t("text")], 2)
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a1d0e4b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1d0e4b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/page-banner/page-banner.vue
// module id = 80
// module chunks = 0